import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { User, Notification, Project, ModuleAccessMap } from '@cosmos/shared';
// import { ProjectsService } from '@cosmos/angular/api';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser$: Observable<User>;

  private currentNotificationsSubject : BehaviorSubject<Notification[]>;
  public currentNotifications$: Observable<Notification[]>;

  private currentProjectSubject : BehaviorSubject<Project>;
  public currentProject$: Observable<Project>;

  private currentModuleAccessSubject : BehaviorSubject<ModuleAccessMap>;
  public currentModuleAccess$: Observable<ModuleAccessMap>;

  private initializedSubject = new BehaviorSubject<boolean>(false);
  readonly isInitialized$ = this.initializedSubject.asObservable();

  private readonly projectListRefreshSubject = new Subject<void>();
  readonly projectListRefresh$ = this.projectListRefreshSubject.asObservable();

  constructor(
    // private projectService: ProjectsService,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(null);
    this.currentUser$ = this.currentUserSubject.asObservable();

    this.currentNotificationsSubject = new BehaviorSubject<Notification[]>([]);
    this.currentNotifications$ = this.currentNotificationsSubject.asObservable();

    this.currentProjectSubject = new BehaviorSubject<Project>(null);
    this.currentProject$ = this.currentProjectSubject.asObservable();

    this.currentModuleAccessSubject = new BehaviorSubject<ModuleAccessMap>(null);
    this.currentModuleAccess$ = this.currentModuleAccessSubject.asObservable();

  }

  markInitialized(): void {
    this.initializedSubject.next(true);
  }

  isInitialized(): boolean {
    return this.initializedSubject.getValue();
  }

  setCurrentUser(user: User): void {
    this.currentUserSubject.next(user);
  }

  getCurrentUser(): User {
    return this.currentUserSubject.getValue();
  }

  isImpersonating(): boolean {
    return !!this.getCurrentUser()?.viewingAs;
  }

  setCurrentNotifications(notifications : Notification[]): void {
    this.currentNotificationsSubject.next(notifications);
  }

  getCurrentNotifications(): Notification[] {
    return this.currentNotificationsSubject.getValue();
  }

  setCurrentProject(project: Project): void {
    this.currentProjectSubject.next(project);
  }

  getCurrentProject(): Project {
    return this.currentProjectSubject.getValue();
  }

  setModuleAccess(access: ModuleAccessMap): void {
    this.currentModuleAccessSubject.next(access);
  }

  getModuleAccess(): ModuleAccessMap {
    return this.currentModuleAccessSubject.getValue();
  }

  refreshProjectList(): void {
    this.projectListRefreshSubject.next();
  }
}

